import styled from 'styled-components'

const TimelineListItem = styled.li`
  box-sizing: border-box;
`

export default TimelineListItem
